<template>
  <div>
    <template v-if="jobsStore.hasFetched">
      <template v-if="jobsStore.jobs?.length > 0">
        <table class="stk-table">
          <thead class="stk-table-head">
            <tr>
              <th class="stk-table-head-col">
                Title
              </th>
              <th class="stk-table-head-col">
                Prompt
              </th>
              <th class="stk-table-head-col">
                Runs
              </th>
              <th class="stk-table-head-col">
                Frequency
              </th>
              <th class="stk-table-head-col">
                Recipients
              </th>
              <th class="stk-table-head-col">
                Enabled?
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(job) in jobsStore.jobs"
              :key="job.id"
              class="stk-table-row"
            >
              <td class="stk-table-cell cell-title">
                <TextLink
                  v-slot="{ navigate }"
                  class="stk-table-cell-link"
                  :to="{ name: 'ai-job-single', params: { jobId: job.id } }"
                >
                  {{ job.title }}
                </TextLink>
              </td>
              <td class="stk-table-cell cell-prompt">
                <TruncatedText :text="job.prompt" />
              </td>
              <td class="stk-table-cell cell-runs">
                {{ job.runs.length }}
              </td>
              <td class="stk-table-cell cell-cron">
                {{ cronstrue.toString(convertUtcCronToLocal(job.cron), { verbose: true }) }}
              </td>
              <td class="stk-table-cell cell-recipients">
                <TruncatedList :items="job.recipients" />
              </td>
              <td class="stk-table-cell cell-toggle">
                <Toggle
                  :checked="job.enabled"
                  :disabled="isToggling"
                  @toggle="next => handleJobToggle(job.id, next)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </template>

      <div
        v-else
        class="stk-px-6"
      >
        No jobs found.
      </div>
    </template>

    <LoaderWithText
      v-else
      class="stk-p-6"
    >
      Loading…
    </LoaderWithText>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import cronstrue from 'cronstrue';
import { ToastProgrammatic as Toast } from 'buefy';
import { useJobsStore } from '@frontend/ui/stores/jobsStore';
import { LoaderWithText, TextLink, Toggle, TruncatedList, TruncatedText } from '@stakeui';
import { convertUtcCronToLocal } from '../cronUtils';

const jobsStore = useJobsStore();

const isToggling = ref(false);

const handleJobToggle = async (jobId, next) => {
  isToggling.value = true;

  try {
    await jobsStore.updateJob(jobId, { enabled: next });

    Toast.open({
      message: `Job successfully updated.`,
      type: 'is-success',
    });
  } catch {
    Toast.open({
      message: `There was an error updating the job.`,
      type: 'is-danger',
    });
  } finally {
    isToggling.value = false;
  }
};

onMounted(async () => {
  await jobsStore.fetchJobs();
});
</script>

<style scoped>
.cell-title {
  color: var(--stk-text-strong);
  width: 16rem;
  padding: 0 !important;
}

.cell-prompt {
  font-size: 0.875em;
}

.cell-runs {
  font-size: 0.875em;
  width: 4em;
}

.cell-cron {
  font-size: 0.875em;
  font-weight: 500;
  width: 16em;
}

.cell-recipients {
  font-size: 0.875em;
  width: 24em;
}

.cell-enabled {
  font-size: 0.875em;
  width: 8em;
}
</style>
